// src/pages/batepapo/BatePapo.js
import React, { useState, useRef, useEffect } from 'react';
import './batepapo.css';

const API_BASE = process.env.REACT_APP_API_BASE;

const BatePapo = () => {
  const [mensagens, setMensagens] = useState([
    {
      id: 1,
      role: 'assistant',
      content:
        'Olá! Eu sou a Luma, sua assistente de nutrição e treino. Estou aqui para te ajudar usando seus dados reais do painel. O que você quer saber hoje?',
    },
  ]);

  const [input, setInput] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const chatRef = useRef(null);

  // Auto scroll sempre que mensagens mudam
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [mensagens, carregando]);

  const enviarMensagem = async () => {
    const texto = input.trim();
    if (!texto || carregando) return;

    setErro('');

    const novaMsgUsuario = {
      id: Date.now(),
      role: 'user',
      content: texto,
    };

    setMensagens((msgs) => [...msgs, novaMsgUsuario]);
    setInput('');
    setCarregando(true);

    try {
      const res = await fetch(`${API_BASE}/assistente-chat.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ mensagem: texto }),
      });

      const data = await res.json();

      if (!res.ok || data.status !== 'sucesso') {
        throw new Error(data.mensagem || 'Erro ao obter resposta da IA.');
      }

      const novaMsgAssistente = {
        id: Date.now() + 1,
        role: 'assistant',
        content: data.resposta,
      };

      setMensagens((msgs) => [...msgs, novaMsgAssistente]);
    } catch (e) {
      setErro('Não consegui falar com a Luma agora. Tente novamente mais tarde.');

      setMensagens((msgs) => [
        ...msgs,
        {
          id: Date.now() + 2,
          role: 'assistant',
          content:
            'Tive um problema técnico para responder agora. Pode tentar de novo em alguns instantes.',
        },
      ]);
    } finally {
      setCarregando(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviarMensagem();
    }
  };

  return (
    <div className="bp-container">

      {/* HEADER LUMINOSO */}
      <header className="bp-header">
        <div className="bp-header-left">
          <img src="/avatar.png" alt="avatar" className="bp-avatar-header" />
          <div>
            <h2>Luma — Assistente Nutri & Treino</h2>
            <p>Baseada nos seus dados reais do painel</p>
          </div>
        </div>

        <a href="/painel" className="bp-voltar">
          <span className="bp-voltar-icone">⬅</span> Voltar para o painel
        </a>
      </header>

      {/* CHAT */}
      <div className="bp-chat" ref={chatRef}>
        {mensagens.map((msg) => (
          <div
            key={msg.id}
            className={
              msg.role === 'user'
                ? 'bp-msg-row user-row'
                : 'bp-msg-row assist-row'
            }
          >
            {/* Avatar apenas na IA */}
            {msg.role === 'assistant' && (
              <img src="/avatar.png" alt="avatar" className="bp-avatar-msg" />
            )}

            <div
              className={
                msg.role === 'user'
                  ? 'bp-msg user-msg'
                  : 'bp-msg assist-msg'
              }
            >
              <p>{msg.content}</p>
            </div>
          </div>
        ))}

        {carregando && (
          <div className="bp-msg-row assist-row">
            <img src="/avatar.png" alt="avatar" className="bp-avatar-msg" />
            <div className="bp-msg assist-msg bp-loading">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        )}
      </div>

      {erro && <div className="bp-erro">{erro}</div>}

      {/* INPUT */}
      <div className="bp-input-area">
        <textarea
          className="bp-input"
          placeholder="Digite sua dúvida..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={1}
        />

        <button
          className="bp-send"
          onClick={enviarMensagem}
          disabled={carregando || !input.trim()}
        >
          Enviar
        </button>
      </div>
    </div>
  );
};

export default BatePapo;
